import handyImage from '../../../assets/Handy.jpg';
import { WebViewTexts } from '../../../language/Texts';
import './Footer.scss';


function Footer() {

    return (
        <div className="dpp-promo-container">
            <div className="dpp-promo-content">
                {/* Left Content */}
                <div className="dpp-promo-text-section">
                    <p className="dpp-promo-subtitle">
                        {WebViewTexts.dppPromoSubtitle}
                    </p>
                    <h2 className="dpp-promo-title">
                        {WebViewTexts.dppPromoTitle}
                    </h2>

                    <div className="dpp-promo-body">
                        <p>{WebViewTexts.dppPromoMainText}</p>
                        <p>{WebViewTexts.dppPromoSubText1}</p>
                        <p>{WebViewTexts.dppPromoSubText2}</p>
                    </div>

                    <button
                        onClick={() => window.open(WebViewTexts.dppUrl, '_blank', 'noopener,noreferrer')}
                        className="dpp-promo-cta-button"
                        type="button"
                    >
                        {WebViewTexts.dppPromoCta}
                    </button>
                </div>

                {/* Right Image */}
                <div className="dpp-promo-image-section">
                    <img
                        src={handyImage}
                        alt="Digital Product Passport Software"
                    />
                </div>
            </div>
        </div>
    );
}

export default Footer;
